/* eslint-disable lingui/no-unlocalized-strings */
const options = [
  {
    label: "中文",
    value: "Chinese",
  },
  {
    label: "English",
    value: "English",
  },
  {
    label: "日本語",
    value: "Japanese",
  },
  {
    label: "Deutsch",
    value: "German",
  },
  {
    label: "Français",
    value: "French",
  },
  {
    label: "한국어",
    value: "Korean",
  },
];
export default options;
